import React, {Component} from 'react';
import {connect} from 'react-redux';

class AssociateLead extends Component {
  constructor(...args) {
    super(...args);

    this.trackMarketoLead = this.trackMarketoLead.bind(this);
  }

  componentDidMount() {
    this.trackMarketoLead();
  }

  /**
   * Track our lead in Marketo with analytics data
   */
  trackMarketoLead() {
    const associateLead = setTimeout(() => {

      if (window.Munchkin && window.analytics) {
        const userData = {
          Email: analytics.user()._getTraits().email,
          FirstName: analytics.user()._getTraits().name.split(' ')[0],
          LastName: analytics.user()._getTraits().name.split(' ')[1],
          Phone: analytics.user()._getTraits().phone,
          Company: analytics.user()._getTraits().company,
          Country: analytics.user()._getTraits().address.country,
          PostalCode: analytics.user()._getTraits().address.postalCode,
          utmcampaign: analytics.user()._getTraits().utmCampaign,
          utmcontent: analytics.user()._getTraits().utmContent,
          utmmedium: analytics.user()._getTraits().utmMedium,
          utmsource: analytics.user()._getTraits().utmSource,
          utmterm: analytics.user()._getTraits().utmTerm
        };

        Munchkin.munchkinFunction('associateLead', userData, this.props.marketoHash);
      
        clearTimeout(associateLead);
      }
    }, 1000);
  }

  render() {
    return <div />
  }
}

const mapStateToProps = (state) => {
  return {
    marketoHash: state.marketoHash
  };
}

export default connect(mapStateToProps)(AssociateLead);



/** WEBPACK FOOTER **
 ** ./src/_shared/components/associateLead/index.jsx
 **/